// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"693":"2e421c3f0285f19a","888":"af392b73333dbe44"}[chunkId] + ".css";
};